import React, { useRef } from 'react'
import styles from './CtaMiddle.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const CtaMiddle: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.CTA} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.ctsTitle}>
          <span className={styles.ctsTitle__sub}>まずはお気軽にご相談ください</span>
        </h2>
        <p className={styles.ctsText}>アプリの構想段階でも、既に走り始めているプロジェクトでも構いません。</p>
        <dl className={styles.ctsBox}>
          <dt className={styles.ctsBox__title}>
            私たちは顧客と共に最適解を探す”伴走開発パートナー”として、
            <br />
            現状の課題を捉え、最適な戦略と体制を再構築します。
          </dt>
          <dd className={styles.ctsBox__btnRed}>
            <a href="#contact">お問い合わせはこちら</a>
          </dd>
        </dl>
        <div className={styles.cta}>
          <a href="/download/application-development/" className={styles.ctaLink}>
            <figure className={styles.ctaLink__image}>
              <img
                src="/images/img/download/application-development/thumbnail_application_dev.webp"
                alt="アプリ開発 発注前チェックリスト"
              />
            </figure>
            <div className={styles.ctaLink__text}>
              <h3 className={styles.ctaLink__text__title}>アプリ発注前にお役立ちの資料</h3>
              <p className={styles.ctaLink__text__text}>
                アプリ開発前にご活用いただける、
                <br />
                チェックリスト資料もご用意しています。
              </p>
              <p className={styles.ctaLink__text__btn}>資料ダウンロードはこちら</p>
            </div>
          </a>
        </div>
      </div>
    </section>
  )
}
export default CtaMiddle
